module.exports = __webpack_public_path__ + "./fonts/UploadIcon.1cedb6e919bfed6a2c1ec00b5d8ee620.svg";


//////////////////
// WEBPACK FOOTER
// ./websources/components/ImageUpload/UploadIcon.svg
// module id = ./websources/components/ImageUpload/UploadIcon.svg
// module chunks = 0